import * as Yup from "yup";

export const totalLearnTimeValidation = Yup.object().shape({
  value: Yup.string().required("وارد کردن ساعت آموزش الزامی است"),
});
